export default {
  // Hero section
  'hero.title': 'পেশাদার অনলাইন টাইমার সরঞ্জাম',
  'hero.subtitle': 'আপনার প্রয়োজনের জন্য নিখুঁত সময় সরঞ্জাম চয়ন করুন',

  // Tool cards
  'timer.title': 'টাইমার',
  'timer.description': 'কাজ, অধ্যয়ন এবং জীবনের জন্য কাউন্টডাউন টাইমার',
  'timer.longDescription': 'উৎপাদনশীলতা, রান্না এবং সময় ব্যবস্থাপনার জন্য কাউন্টডাউন টাইমার',
  'timer.button': 'টাইমার শুরু করুন',

  'stopwatch.title': 'স্টপওয়াচ',
  'stopwatch.description': 'উচ্চ-নির্ভুলতা সময় সরঞ্জাম',
  'stopwatch.longDescription': 'খেলাধুলা, প্রশিক্ষণ এবং নির্ভুল সময় নির্ধারণের জন্য উচ্চ-নির্ভুলতা স্টপওয়াচ',
  'stopwatch.button': 'স্টপওয়াচ শুরু করুন',

  'worldclock.title': 'বিশ্ব ঘড়ি',
  'worldclock.description': 'বিশ্বব্যাপী সময় অঞ্চল দেখুন',
  'worldclock.longDescription': 'স্মার্ট সময় অঞ্চল গণনা সহ বিশ্বব্যাপী প্রধান শহরের সময় রিয়েল-টাইম প্রদর্শন',
  'worldclock.button': 'বিশ্ব ঘড়ি দেখুন',

  // Features section
  'features.title': 'কেন timer.today নির্বাচন করবেন?',
  'features.reliable.title': 'নির্ভরযোগ্য এবং নির্ভুল',
  'features.reliable.desc': 'ব্রাউজার-ভিত্তিক নির্ভরযোগ্যতা সহ মিলিসেকেন্ড নির্ভুলতা সময়',
  'features.crossPlatform.title': 'ক্রস-প্ল্যাটফর্ম',
  'features.crossPlatform.desc': 'ডেস্কটপ, ট্যাবলেট এবং মোবাইল ডিভাইসে নির্বিঘ্নে কাজ করে',
  'features.smartNotifications.title': 'স্মার্ট বিজ্ঞপ্তি',
  'features.smartNotifications.desc': 'সময় শেষ হলে শব্দ সতর্কতা এবং ডেস্কটপ বিজ্ঞপ্তি',
  'features.easyToUse.title': 'ব্যবহার করা সহজ',
  'features.easyToUse.desc': 'সকল ব্যবহারকারীদের জন্য স্বজ্ঞাত নিয়ন্ত্রণ সহ পরিষ্কার ইন্টারফেস',

  // Keywords section
  'keywords.timer': 'টাইমার কাউন্টডাউন পোমোডোরো ফোকাস কাজ বিরতি',
  'keywords.chinese': '计时器 倒计时 番茄钟 专注 休息',
  'keywords.japanese': 'タイマー カウントダウン ポモドーロ 集中 休憩',
  'keywords.spanish': 'temporizador cuenta regresiva pomodoro concentración',
  'keywords.german': 'Timer Countdown Pomodoro Konzentration Pause',
  'keywords.french': 'minuteur compte à rebours pomodoro concentration',
  'keywords.russian': 'таймер обратный отсчет помодоро концентрация',
};
